import { render } from "./BookAppointment.vue?vue&type=template&id=7a4f978d&scoped=true"
import script from "./BookAppointment.vue?vue&type=script&lang=js"
export * from "./BookAppointment.vue?vue&type=script&lang=js"

import "./BookAppointment.vue?vue&type=style&index=0&id=7a4f978d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4f978d"]])

export default __exports__